import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { TypePaymentStatus } from './../api/models/type-payment-status';

@Directive({
  selector: '[paymentStatusStyle]',
  standalone: true,
})
export class PaymentStatusDirective implements OnInit {
  @Input('paymentStatusStyle') status: TypePaymentStatus;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi tw-font-bold mdi-20px ';

    switch (this.status) {
      case TypePaymentStatus.Checking:
        classList += ' mdi-circle-slice-4 text-info mdi-spin';
        break;
      case TypePaymentStatus.Confirmed:
        classList += 'mdi-check-bold text-success';
        break;
      case TypePaymentStatus.Rejected:
        classList += 'mdi-close-thick text-danger';
        break;
      case TypePaymentStatus.Lending:
        classList += 'mdi-cash-clock text-primary';
        break;
      case TypePaymentStatus.WatingForPay:
        classList += ' mdi-circle-slice-4 text-warning mdi-spin';
        break;

      default:
        break;
    }
    return classList;
  }
}
